// extracted by mini-css-extract-plugin
export default {"logs-view":"logs_logs-view__wW0Q2"};